import { Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { isVideov2 } from "../../helpers/isVideo";

function CardSubProducto({ prod, titleProd }) {
  const [newTitle, setNewTitle] = useState("");
  const { _id } = prod;

  const changeUrl = (_id) => {
    setNewTitle(_id);
  };

  useEffect(() => {
    changeUrl(_id);
  }, []);

  return (
    <Card key={prod._id} style={{ width: "19.6rem" }} className="card-product">
      <a href={`/producto/${titleProd}/${newTitle}`}>
        <Card.Title className="title-producto">{prod.subCategory}</Card.Title>
        <div className="image-card">
          {isVideov2(prod?.imageProduct ? prod?.imageProduct?.[0]?.url : "") ? (
            <video
              src={prod?.imageProduct ? prod?.imageProduct?.[0]?.url : ""}
              controls
              className="mt-3"
              style={{
                width: '100%',
                height: '80%',
                objectFit: 'contain',
              }}
            />
          ) : (
            <Card.Img
              variant="top"
              src={prod?.imageProduct?.[0]?.url}
              alt={prod.imageProduct ? prod.imageProduct[0]?.alt : prod?.title}
              title={prod?.title}
            />
          )}
        </div>
        <Card.Body>
          <Card.Title className="nombre-producto">{prod?.title}</Card.Title>
          <Divider className="divider" />
          <Card.Text className="info-producto">
            Dimensiones: {prod?.dimension}
            <br />
            Cantidad: {prod?.quantity}
            <br />
            Peso: {prod?.weight} kg
          </Card.Text>
        </Card.Body>
      </a>
      <div className="colores-card">
      </div>
    </Card>
  );
}

export default CardSubProducto;
